import { Alert, Typography, useTheme } from '@mui/material';
import { FC, useCallback, useState } from 'react';
import { ConfirmDeletionDialog } from '../../../../components/Dialog/ConfirmDialog/ConfirmDeletionDialog';
import { Loader } from '../../../../components/Loader/Loader';
import { getRoundLabel } from '../../../../util/preference-utils';
import { pluralizeWord } from '../../../../util/stringUtils';
import { useDryRunDeleteInvestment } from '../../hooks/useDryRunDeleteInvestment';
import { useInvestmentActions } from '../../hooks/useInvestmentActions';
import { IInvestmentFormModalProps } from './EditInvestmentModal';

export const DeleteInvestmentModal: FC<IInvestmentFormModalProps> = ({ open, onClose, investment }) => {
  const { handleDeleteInvestment } = useInvestmentActions();
  const { nAttachedTransactions, loading: awaitingDryRunResponse } = useDryRunDeleteInvestment(investment.id);
  const [loading, setLoading] = useState(false);
  const { colors } = useTheme();
  const roundLabel = getRoundLabel().toLowerCase();

  const handleDelete = useCallback(async () => {
    setLoading(true);
    await handleDeleteInvestment(investment);
    setLoading(false);
    onClose();
  }, [onClose, handleDeleteInvestment, investment]);

  return open ? (
    <ConfirmDeletionDialog
      open={open}
      onClose={onClose}
      onConfirm={handleDelete}
      title={`Are you sure you want to delete this ${roundLabel}?`}
      loading={loading}
    >
      {awaitingDryRunResponse ? (
        <Loader />
      ) : (
        <>
          <Typography variant='body2' color={colors.neutral[60]}>
            {`The ${roundLabel} ${investment.name ?? ''} will be deleted permanently`}
          </Typography>
          {nAttachedTransactions ? (
            <>
              <Alert severity='warning' sx={{ my: '1rem' }} role='alert'>
                {`This ${roundLabel} has ${nAttachedTransactions} ${pluralizeWord('transaction')} attached, are you sure you would like to delete it?`}
                <br />
                {`You can reassign the transactions to another existing ${roundLabel}.`}
              </Alert>
            </>
          ) : (
            <div />
          )}
        </>
      )}
    </ConfirmDeletionDialog>
  ) : (
    <div />
  );
};
